import produce from "immer";
import {
  SET_LABELING_HISTORY,
  GET_LABELING_HISTORY,
  GET_LABELING_HISTORY_SUCCESS,
  GET_LABELING_HISTORY_ERROR,
  SET_LABELING_HISTORY_DISPLAY,
} from "./constants";

/*
export interface LabelingHistory {
  historyId: string
  sourceId: string
  userId: string
  roleCode: string
  previousSourceStatus: string
  sourceStatus: string
  isGroundTruth: boolean
  comparedStatus: string
  comparedDate: any
  labelingData: LabelingDaum[]
  groundTruthId: any
  compareResult: any
  createdBy: string
  createdDate: string
  updatedBy: any
  updatedDate: any
  deletedFlag: boolean
  userInfo: UserInfo
}

export interface LabelingDaum {
  labelId: string
  labelPoints: LabelPoint[]
  labelTypeName: string
  classesTypeCode: string
  labelTypeColor: string
}

export interface LabelPoint {
  dataPoint: any
  labelPointId: string
}

export interface UserInfo {
  userId: string
  email: string
  fullName: string
  imagePreviewPath: string
}
*/

const processLabelingHistory = ({ state, histories = [] }) => {
  const labelTypesMap = new Map();
  const usersMap = new Map();

  histories.forEach((history) => {
    const { userId, roleCode, userInfo, labelingData = [] } = history;

    labelingData.forEach((item) => {
      if (item && item.labelPoints && item.labelPoints.length > 0) {
        const key = item.labelId;
        if (key && !labelTypesMap.has(key)) {
          labelTypesMap.set(key, {
            labelId: item.labelId,
            labelTypeName: item.labelTypeName,
            classesTypeCode: item.classesTypeCode,
          });
        }
      }
    });

    if (userId && !usersMap.has(userId)) {
      usersMap.set(userId, {
        userId,
        email: userInfo?.email || "",
        fullName: userInfo?.fullName || "",
        imagePreviewPath: userInfo?.imagePreviewPath || "",
        roleCode,
      });
    }
  });

  const users = Array.from(usersMap.values());
  const labelTypes = Array.from(labelTypesMap.values()).sort((a, b) =>
    a.labelTypeName.localeCompare(b.labelTypeName)
  );

  state.users = users;
  state.labelTypes = labelTypes;
  state.histories = histories;
};

export const initialState = {
  loading: false,
  error: null,
  histories: [], // LabelingHistory[]
  labelTypes: [],
  users: [],
  shapes: [],
  displayingShapes: [],
  shapesByLabel: {},
};

const reducer = (state = initialState, action) =>
  produce(state, (draft) => {
    switch (action.type) {
      case SET_LABELING_HISTORY: {
        processLabelingHistory({ state: draft, histories: action.payload });
        break;
      }
      case GET_LABELING_HISTORY:
        draft.loading = true;
        draft.error = null;
        break;
      case GET_LABELING_HISTORY_SUCCESS: {
        draft.loading = false;
        processLabelingHistory({ state: draft, histories: action.payload });
        break;
      }
      case GET_LABELING_HISTORY_ERROR:
        draft.loading = false;
        draft.error = action.payload;
        break;
      case SET_LABELING_HISTORY_DISPLAY: {
        const {
          displayingShapes = [],
          shapes = [],
          shapesByLabel = {},
        } = action.payload;
        draft.shapesByLabel = shapesByLabel;
        draft.shapes = shapes;
        draft.displayingShapes = displayingShapes;
        break;
      }
      default:
        break;
    }
  });

export default reducer;
